import * as React from 'react';

interface ISecondaryNavProps {
    performanceDate: string;
    performanceTime: string;
    performanceVenue: string;
}

class SecondaryNav extends React.PureComponent<ISecondaryNavProps, { showCartConflictDialog: boolean }>{

    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div className="seatmap-header seatmap-header-filter">
                <p className="caption-paragraph">
                    {
                        this.props.performanceDate !== null
                            ?
                            <span className="seatmap-header-date">{this.props.performanceDate}, </span>
                            : null
                    }
                    {
                        this.props.performanceTime !== null
                            ?
                            <span className="seatmap-header-time">{this.props.performanceTime}, </span>
                            : null
                    }
                    {

                        this.props.performanceVenue.length >= 0 ?
                            <span className="seatmap-header-venue">{this.props.performanceVenue}</span>
                            : null
                    }
                </p>
            </div>
        );
    }
}

export default SecondaryNav;